(function () {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    /**
     * A service for creating a file chooser. Invoke by calling {@link ihh-common-web.IhhFileChooser.open open}.
     * @ngdoc service
     * @name IhhFileChooser
     * @memberOf ihh-common-web
     * @param {Object} $modal the injected ui-boostrap service for modal dialogs
     */
    angular
        .module('ihh-common-web')
        .service('IhhFileChooser', IhhFileChooser);

    IhhFileChooser.$inject = ['$modal'];

    function IhhFileChooser($modal) {

        /**
         * Defines the behavior of a file chooser.
         * @typedef {Object} Config
         * @name Config
         * @memberOf ihh-common-web.IhhFileChooser
         * @property {string} title a title for the file chooser dialog
         * @property {string} message a message displayed in the file chooser dialog
         * @property {string} mediaType a string specifying the type of media
         */

        /**
         * Called when a file is chosen by the user.
         * @callback SelectedFn
         * @memberOf ihh-common-web.IhhFileChooser
         * @param {Object} picked the picked file or blob
         */

        /**
         * Called when the dialog is canceled by the user without choosing a file.
         * @callback CanceledFn
         * @memberOf ihh-common-web.IhhFileChooser
         */

        /**
         * Opens a file chooser. If the user selects a file, then **selectedFn** is called. If the user cancels then nothing happens.
         * @ngdoc method
         * @name open
         * @memberOf ihh-common-web.IhhFileChooser
         * @param {ihh-common-web.IhhFileChooser.Config} config a configuration object specifying behavior of the chooser
         * @param {ihh-common-web.IhhFileChooser.SelectedFn} selectedFn called when a file is picked
         * @param {ihh-common-web.IhhFileChooser.CanceledFn} canceledFn called when a file is picked
         */
        this.open = function(config, selectedFn, canceledFn) {
            var modalInstance = $modal.open({
                templateUrl: 'file-chooser/file-chooser.tpl.html',
                controller: 'IhhFileChooserCtrl',
                resolve: {
                    config: function() {
                        return config;
                    },
                    selectedFn: function() {
                        return selectedFn;
                    }
                }
            });

            modalInstance.result.then(function(item) {
                if (selectedFn) {
                    selectedFn(item);
                }
            }, function() {
                if (canceledFn) {
                    canceledFn();
                }
            });
        };
    }
})();